import * as tslib_1 from "tslib";
import { getComponentTitleByControlType, getPcComponentByControlType } from '../../../../../form/utils';
import { Icon, Modal, Tooltip } from "@h3/antd-vue";
import { Component, Inject } from "vue-property-decorator";
import { FormControlType } from "../../typings";
import ControlAdapter from "../control-adapter";
import Description from "../layout/description.vue";
import FormTitle from "../layout/form-title.vue";
import BaseControlAdapter from "./base-control-adapter.vue";
import SystemControl from "./system-control.vue";
let PcControlAdapter = class PcControlAdapter extends ControlAdapter {
    constructor() {
        super(...arguments);
        this.isFullScreen = false;
        this.frozenKeys = [];
    }
    get titleVisible() {
        return this.control.options.labelVisible;
    }
    created() {
        const comp = getPcComponentByControlType(FormControlType.Sheet);
        const ReverseRelevance = getPcComponentByControlType(FormControlType.ReverseRelevance);
        if (comp && comp.pc) {
            this.$options.components.FormSheet = comp.pc;
        }
        if (ReverseRelevance && ReverseRelevance.pc) {
            this.$options.components.ReverseRelevance = ReverseRelevance.pc;
        }
    }
    fullScreen() {
        this.isFullScreen = !this.isFullScreen;
        try {
            if (this.isFullScreen) {
                // @ts-ignore
                window.parent.window.document.querySelector('.icon-close').style.display = 'none';
            }
            else {
                // @ts-ignore
                window.parent.window.document.querySelector('.icon-close').style.display = 'block';
            }
        }
        catch (error) {
        }
    }
    onFreezeColumn(key, freeze) {
        if (freeze) {
            this.frozenKeys.push(key);
        }
        else {
            const index = this.frozenKeys.findIndex(k => k === key);
            if (index > -1) {
                this.frozenKeys.splice(index, 1);
            }
        }
    }
    get readonly() {
        return this.ctrl ? this.ctrl.readonly : false;
    }
    get typeClass() {
        const type = this.control.type;
        if (this.control.diff) {
            console.log(this.control.value);
        }
        const name = FormControlType[type] || getComponentTitleByControlType(type);
        return name ? name.toLowerCase() : '';
    }
    get formPermissionData() {
        return this.getFormPermission();
    }
    get layoutType() {
        if (this.layoutTypeFn) {
            return this.layoutTypeFn();
        }
    }
    get disabled() {
        return this.ctrl ? this.ctrl.disabled : false;
    }
    get fieldClassObj() {
        return {
            vertical: this.layoutType,
            error: this.hasError,
            required: this.required && !this.disabled,
            edit: this.control.edit,
            diffControls: this.control.diff
        };
    }
};
tslib_1.__decorate([
    Inject()
], PcControlAdapter.prototype, "layoutTypeFn", void 0);
tslib_1.__decorate([
    Inject()
], PcControlAdapter.prototype, "getFormPermission", void 0);
PcControlAdapter = tslib_1.__decorate([
    Component({
        name: "control-adapter",
        components: {
            AModal: Modal,
            ATooltip: Tooltip,
            AIcon: Icon,
            BaseControlAdapter,
            FormTitle,
            Description,
            SystemControl,
            // ReverseRelevance: () => import(/* webpackChunkName: "reverse-relevance" */"./reverse-relevance/reverse-relevance.vue"),
            FormTabs: () => import(/* webpackChunkName: "pc-form-tabs" */ "../layout/pc-form-tabs.vue"),
        }
    })
], PcControlAdapter);
export default PcControlAdapter;
